import { createAction } from '@reduxjs/toolkit';
import { ViewModeShape } from './model';

export const changed = createAction<{ viewMode: ViewModeShape['viewMode'] }, 'al/viewMode/changed'>(
  'al/viewMode/changed',
);

export const expandedChanged = createAction<
  { expanded: ViewModeShape['expanded'] },
  'al/viewMode/expandedChanged'
>('al/viewMode/expandedChanged');
